import React from 'react';
import { connect } from 'react-redux';
import { formValueSelector, change } from 'redux-form'

import { getAll as fetchAllPaymentMethods } from 'billing/paymentMethods/actions';
import { createRenewal } from 'billing/purchases/actions';
import { getAllocations, getBypassedAllocations, clearAllocations  } from 'billing/renewal/actions';
import { fetchFiltered as fetchFilteredPurchases } from 'billing/purchases/actions';
import { fetch as fetchCycles } from 'billing/cycles/actions';
import { arrangePayment } from '../actions';
import {
  getUser,
  getOverduePurchases,
  getAllPaymentMethods,
  getRenewalPurchase,
  getCurrentCycle,
  getRenewalUnpaid,
} from 'reducers';
import { daysLeftInCycle } from 'billing/cycles/utils';
import PaymentArrangementRequestForm from '../PaymentArrangementRequestForm';
import { getDate, getDayAndMonthAndYear } from '../../helpers/formatters';
import SuccessArrangementModal from '../SuccessArrangementModal';

import styles from './index.module.css';


class PaymentArrangementRequest extends React.Component {

  state = {
    successData: {},
    loading: false,
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.user !== this.props.user) {
      this.fetchData();
    }

    if (prevProps.success !== this.props.success) {
      this.setState({ loading: false });
    }

    if (
      prevProps.daysLeftInCycle !== this.props.daysLeftInCycle ||
      prevProps.user !== this.props.user ||
      prevProps.renewalUnpaid !== this.props.renewalUnpaid
    ) {
      if (
        this.props.renewalUnpaid && 
        this.props.user &&
        (this.props.daysLeftInCycle || this.props.daysLeftInCycle === 0)
        && this.props.daysLeftInCycle <= 6
      ) {
        this.props.createRenewal(this.props.user.id);
      }
    }

    if (prevProps.selectedPurchaseId && prevProps.selectedPurchaseId !== this.props.selectedPurchaseId) {
      this.props.changeField('paymentArrangementRequest', 'arrangement_date', '');
    }
  }

  fetchData = () => {
    const {
      user,
      success,
      fetchFilteredPurchases,
      fetchAllPaymentMethods,
      fetchCycles,
      getAllocations,
      getBypassedAllocations,
      clearAllocations,
    } = this.props;
    if (user && !success) {
      this.setState({ loading: true });
      Promise.all([
        clearAllocations(),
        fetchCycles(),
        getAllocations(user.id),
        getBypassedAllocations(user.id),
        fetchFilteredPurchases(user.id, { status: 'overdue', purchase_type: 'renewal' }),
        fetchAllPaymentMethods(user.id),
      ])
        .then(() => this.setState({ loading: false }))
        .catch(() => this.setState({ error: '', loading: false }))
    }
  }

  handleSubmit = (values) => {
    const { arrangePayment, paymentMethods, selectedPurchase } = this.props;
    const card = paymentMethods.find(c => c.id == values.payment_method_id);

    this.setState({
      loading: true,
      error: '',
      successData: {
        purchaseId: values.purchase_id,
        date: getDayAndMonthAndYear(values.arrangement_date),
        total: selectedPurchase.cost.total,
        cardLastFour: card.card_last_four
      }
    });
    let chargeDate = new Date(values.arrangement_date);

    arrangePayment(values.purchase_id, {
      card_id: values.payment_method_id,
      charge_date: getDate(chargeDate),
    })
  }

  render() {
    const { overduePurchases, paymentMethods, success, selectedPurchase, renewalPurchase } = this.props;
    let filteredPurchases = overduePurchases.filter(p => p.purchase_type === 'renewal');
    if (renewalPurchase && renewalPurchase.status === 'pending') {
      filteredPurchases = [renewalPurchase, ...filteredPurchases];
    }

    const { successData } = this.state;
    return (
      <div className={styles.orderSim}>
        <div className={styles.titleWrapper}>
          <h1 className={styles.title}>Payment Arrangement Request</h1>
        </div>
        <PaymentArrangementRequestForm
          selectedPurchase={selectedPurchase}
          purchases={filteredPurchases}
          paymentMethods={paymentMethods}
          onSubmit={this.handleSubmit}
        />
        <SuccessArrangementModal isOpen={Boolean(success)} data={successData} />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const selector = formValueSelector('paymentArrangementRequest');
  const success = state.routing.query && state.routing.query.success;
  const overduePurchases = getOverduePurchases(state);
  const renewalPurchase = getRenewalPurchase(state);
  const selectedPurchaseId = selector(state, 'purchase_id');
  const selectedPurchase = (renewalPurchase && renewalPurchase.id == selectedPurchaseId && renewalPurchase) ||
                            overduePurchases.find(p => p.id == selectedPurchaseId);
  const cycle = getCurrentCycle(state);
  
  return {
    user: getUser(state),
    paymentMethods: getAllPaymentMethods(state),
    overduePurchases,
    selectedPurchaseId,
    selectedPurchase,
    success,
    renewalPurchase,
    renewalUnpaid: getRenewalUnpaid(state),
    daysLeftInCycle: cycle ? daysLeftInCycle(cycle.end_date) : null,
    currentCycle: cycle,
  }
};

const mapDispatchToProps = {
  fetchFilteredPurchases,
  fetchAllPaymentMethods,
  arrangePayment,
  createRenewal,
  changeField: change,
  fetchCycles,
  getAllocations,
  getBypassedAllocations,
  clearAllocations,
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentArrangementRequest);